module.exports = __webpack_public_path__ + "img/stray-canyon.11893668.jpg";